<template>
  <div class="mine page">
    <div class="wrapper">
      <van-pull-refresh :border="false" class="list-wrapper" v-model="isLoading" @refresh="onRefresh">
        <header class="mine-header">
          <div class="header-actions">
            <button type="button" class="header-action" aria-label="Settings" @click="showSetting()">
              <van-icon name="setting-o" />
            </button>
            <button type="button" class="header-action" aria-label="Log out" @click="loginout()">
              <van-icon name="exchange" />
            </button>
          </div>

          <div class="mine-brand">
            <VictoriaBrand compact />
          </div>
          <p v-if="userInfo.username" class="account-name">{{ userInfo.username }}</p>
        </header>

        <section class="stats-card" aria-label="Account summary">
          <div class="stat-item">
            <img class="stat-crown" src="/img/victoria/crown-icon.png" alt="" aria-hidden="true">
            <div class="stat-label">Account point</div>
            <div class="stat-value">{{ formatAmount(userInfo.money) }}</div>
          </div>
          <div class="stat-item">
            <img class="stat-crown" src="/img/victoria/crown-icon.png" alt="" aria-hidden="true">
            <div class="stat-label">Trust</div>
            <div class="stat-value">{{ trustScore }}</div>
          </div>
          <div class="stat-item">
            <img class="stat-crown" src="/img/victoria/crown-icon.png" alt="" aria-hidden="true">
            <div class="stat-label">Number of film</div>
            <div class="stat-value">0</div>
          </div>
        </section>

        <nav class="menu-list" aria-label="Account actions">
          <button
            v-for="item in menuItems"
            :key="item.label"
            type="button"
            class="menu-item"
            @click="handleMenu(item)"
          >
            <span class="menu-icon" aria-hidden="true">
              <van-icon :name="item.icon" />
            </span>
            <span class="menu-label">{{ item.label }}</span>
            <van-icon class="menu-chevron" name="arrow" aria-hidden="true" />
          </button>
        </nav>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import VictoriaBrand from '../../common/VictoriaBrand'

export default {
  components: {
    VictoriaBrand
  },
  data() {
    return {
      isLoading: false,
      userInfo:{
      },
      menu_top:40
    };
  },
  computed: {
    trustScore() {
      return this.userInfo.credit_score !== undefined && this.userInfo.credit_score !== null
        ? this.userInfo.credit_score
        : 100
    },
    menuItems() {
      return [
        { label: 'Withdraw money', icon: 'balance-pay', action: 'withdraw' },
        { label: 'Deposit money', icon: 'balance-o', path: '/Recharge' },
        { label: 'Personal information', icon: 'contact', action: 'information' },
        { label: 'Withdrawal records', icon: 'records', path: '/WithdrawRecord' },
        { label: 'Deposit history', icon: 'chart-trending-o', path: '/Moneylog' },
        { label: 'Transaction records', icon: 'notes-o', path: '/RechargeRecord' },
        { label: 'System notifications', icon: 'bell', action: 'notice' }
      ]
    }
  },
  methods: {
    formatAmount(value) {
      const amount = Number(value)
      return Number.isFinite(amount) ? amount.toFixed(2) : '0.00'
    },
    handleMenu(item) {
      if (item.action === 'withdraw') {
        this.doWithdrawal()
      } else if (item.action === 'information') {
        this.doLogin()
      } else if (item.action === 'notice') {
        this.toNotice()
      } else if (item.path) {
        this.$router.push({ path: item.path })
      }
    },
    refresh(){
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if(localStorage.getItem('token')){
          this.$toast(this.$t("reservation.refresh"));
        }else{
          this.$router.push({path:'/Login'})
        }
      }, 500);
    },
    loginout(){
      localStorage.removeItem('iframeMap')
      localStorage.removeItem('passNextKeyKeys')
      localStorage.removeItem('waitForEnterForFilteredHints')
      localStorage.removeItem('settingsVersion')
      localStorage.removeItem('collectConfig')
      localStorage.removeItem('loglevel:webpack-dev-server')
      localStorage.removeItem('token')
      this.$router.push({path:'/Login'});
    },
    exit(){
      this.$toast(this.$t("my.finish_task"));
    },
    showSetting() {
      if(localStorage.getItem('token')){
        this.$router.push({path:'/Setting'})
      }else{
        this.$router.push({path:'/Login'})
      }
    },
    toNotice(){
      if(localStorage.getItem('token')){
        this.$router.push({path:'/Notice'})
      }else{
        this.$router.push({path:'/Login'})
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if(localStorage.getItem('token')){
            this.getUserInfo();
            this.$toast(this.$t("reservation.refresh"));
        }else{
            this.$router.push({path:'/Login'})
        }
      }, 500);
    },
    doLogin(){
        if(localStorage.getItem('token')){
            this.$router.push({path:'/Infomation'});
        }else {
            this.$router.push({path:'/Login'})
        }
    },
    doWallet(){
      this.$router.push({
        name:'Wallet'
      })
    },
    doWithdrawal(){
      this.$http({
        method: 'get',
        url: 'getWithdrawalChannels'
      }).then(res=>{
          if(res.code === 200){
            const hasChannel = (res.data.erc20 && res.data.erc20 !== '') || 
              (res.data.cashapp && res.data.cashapp !== '') || 
              (res.data.paypal && res.data.paypal !== '');
            
            if(hasChannel){
              this.$router.push("withdraw");
            }else {
              this.$router.push("Setbank?from=withdraw");
              this.$toast.fail('Please bind withdrawal channel first');
            }
          }
      })
    },
    toService(){
      if(this.$store.getters.getBaseInfo.iskefu == 1){
        this.$router.push("ServiceOnline");
      }else {
        this.$toast.fail(this.$t("setting.forbid"));
      }
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
            this.userInfo = res.data;
            this.menu_top = 15;
            if(this.userInfo.status !== 1){
              this.$toast(this.$t("video.account_out"));
              localStorage.clear()
              this.$router.push({path:'/Login'})
            }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
  },
  created() {
    if(localStorage.getItem('token')){
        this.getUserInfo();
    }else {
      this.userInfo.username = this.$t("setting.log_reg");
      this.userInfo.ip = this.$t("setting.more_service");
      this.userInfo.header_img = "img/mine/avatar.png";
    }
  }
};
</script>

<style scoped>
.icon-wallet:before { content: '💳'; }
.icon-deposit:before { content: '💰'; }
.icon-info:before { content: '👤'; }
.icon-record:before { content: '💵'; }
.icon-history:before { content: '📊'; }
.icon-history2:before { content: '📋'; }
.icon-notification:before { content: '🔔'; }
</style>

<style scoped>
.mine {
  position: absolute;
  inset: 0;
  bottom: 0;
  color: var(--victoria-text);
}

.mine .wrapper {
  position: absolute;
  inset: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.list-wrapper {
  min-height: 100%;
  padding: 0 0.42rem calc(2.12rem + env(safe-area-inset-bottom));
}

.mine-header {
  position: relative;
  padding-top: 0.26rem;
}

.header-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 1.18rem;
}

.header-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.18rem;
  height: 1.18rem;
  padding: 0;
  color: var(--victoria-primary);
  background: rgba(12, 9, 12, 0.56);
  border: 1px solid rgba(231, 160, 174, 0.34);
  border-radius: 50%;
  box-shadow: inset 0 0 0.34rem rgba(231, 160, 174, 0.04), 0 0 0.35rem rgba(0, 0, 0, 0.3);
}

.header-action:active {
  color: var(--victoria-light-rose);
  background: rgba(58, 40, 49, 0.72);
}

.header-action .van-icon {
  color: inherit;
  font-size: 0.59rem;
}

.header-action:focus-visible {
  outline: 2px solid var(--victoria-light-rose);
  outline-offset: 2px;
}

.mine-brand {
  position: relative;
  display: flex;
  width: 4.58rem;
  height: 4.58rem;
  margin: -0.18rem auto 0;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(231, 160, 174, 0.66);
  border-radius: 50%;
  box-shadow: inset 0 0 0.52rem rgba(231, 160, 174, 0.06), 0 0 0.48rem rgba(231, 160, 174, 0.12);
}

.mine-brand::before,
.mine-brand::after {
  position: absolute;
  z-index: 2;
  width: 0.12rem;
  height: 0.12rem;
  content: '';
  background: #fff6f7;
  border-radius: 50%;
  box-shadow: 0 0 0.16rem 0.07rem rgba(255, 209, 217, 0.66);
}

.mine-brand::before {
  top: 0.14rem;
  left: 0.86rem;
}

.mine-brand::after {
  right: 0.2rem;
  bottom: 0.75rem;
}

.mine-brand ::v-deep .victoria-brand,
.mine-brand ::v-deep .victoria-brand__logo {
  width: 4.32rem;
  max-width: none;
}

.mine-brand ::v-deep .victoria-brand__logo {
  border-radius: 50%;
  clip-path: circle(50% at 50% 50%);
}

.account-name {
  margin: 0.16rem 0 0;
  overflow: hidden;
  color: var(--victoria-light-rose);
  font-family: var(--victoria-font-ui);
  font-size: 0.64rem;
  font-weight: 400;
  line-height: 1.2;
  text-align: center;
  text-overflow: ellipsis;
  text-shadow: 0 0 0.28rem rgba(231, 160, 174, 0.34);
  white-space: nowrap;
}

.stats-card {
  position: relative;
  z-index: auto !important;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  width: auto;
  margin: 0.48rem 0 0;
  padding: 0;
  overflow: hidden;
  background: linear-gradient(145deg, rgba(66, 44, 53, 0.78), rgba(25, 20, 25, 0.92));
  border: 1px solid rgba(231, 160, 174, 0.44);
  border-radius: 0.52rem;
  box-shadow: var(--victoria-shadow), inset 0 1px 0 rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}

.stat-item {
  position: relative;
  min-width: 0;
  padding: 0.44rem 0.14rem 0.5rem;
  text-align: center;
}

.stat-item + .stat-item::before {
  position: absolute;
  top: 0.5rem;
  bottom: 0.42rem;
  left: 0;
  width: 1px;
  content: '';
  background: var(--victoria-divider);
}

.stat-item + .stat-item::after {
  position: absolute;
  top: 50%;
  left: -0.01rem;
  width: 0.05rem;
  height: 0.05rem;
  content: '';
  background: var(--victoria-light-rose);
  border-radius: 0.02rem;
  box-shadow: 0 0 0.12rem rgba(255, 209, 217, 0.65);
  transform: translateY(-50%) rotate(45deg);
}

.stat-crown {
  display: block;
  width: 0.48rem;
  height: 0.36rem;
  margin: 0 auto;
  object-fit: contain;
  filter: drop-shadow(0 0 0.09rem rgba(255, 209, 217, 0.42));
}

.stat-label {
  min-height: 0.64rem;
  margin-top: 0.08rem;
  color: rgba(248, 241, 243, 0.86);
  font-size: 0.3rem;
  font-variant-caps: small-caps;
  letter-spacing: 0.015rem;
  line-height: 1.18;
}

.stat-value {
  margin-top: 0.08rem;
  overflow: hidden;
  color: var(--victoria-light-rose);
  font-family: var(--victoria-font-numeric);
  font-variant-numeric: lining-nums tabular-nums;
  font-size: clamp(0.4rem, 5vw, 0.55rem);
  font-weight: 500;
  line-height: 1.25;
  text-shadow: 0 0 0.22rem rgba(231, 160, 174, 0.22);
  text-overflow: ellipsis;
}

.menu-list {
  display: block;
  margin-top: 0.5rem;
  overflow: hidden;
  background: rgba(17, 14, 18, 0.88);
  border: 1px solid rgba(231, 160, 174, 0.36);
  border-radius: 0.48rem;
  box-shadow: var(--victoria-shadow);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}

.menu-item {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 1.48rem;
  padding: 0.2rem 0.44rem;
  color: var(--victoria-text);
  text-align: left;
  background: transparent;
  border: 0;
  border-bottom: 0;
}

.menu-item + .menu-item::before {
  position: absolute;
  top: 0;
  right: 0.46rem;
  left: 1.66rem;
  height: 1px;
  content: '';
  background: var(--victoria-divider);
}

.menu-item:active {
  background: rgba(231, 160, 174, 0.08);
}

.menu-icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 0.9rem;
  height: 0.9rem;
  margin-right: 0.34rem;
  color: var(--victoria-primary);
  background: rgba(12, 9, 12, 0.58);
  border: 1px solid rgba(231, 160, 174, 0.44);
  border-radius: 50%;
  box-shadow: inset 0 0 0.3rem rgba(231, 160, 174, 0.06);
}

.menu-icon .van-icon {
  color: inherit;
  font-size: 0.47rem;
}

.menu-item:not(:last-child) .menu-icon::after {
  position: absolute;
  top: 1.08rem;
  left: 50%;
  width: 0.03rem;
  height: 0.03rem;
  content: '';
  background: var(--victoria-light-rose);
  border-radius: 0.02rem;
  box-shadow: 0 0 0.1rem rgba(255, 209, 217, 0.52);
  transform: translateX(-50%) rotate(45deg);
}

.menu-label {
  flex: 1;
  color: var(--victoria-text);
  font-size: 0.25rem;
  font-variant-caps: small-caps;
  font-weight: 400;
  letter-spacing: 0.025rem;
  text-transform: uppercase;
}

.menu-chevron {
  margin-left: 0.25rem;
  color: rgba(248, 241, 243, 0.68);
  font-size: 0.48rem;
}

.menu-item:focus-visible {
  outline: 2px solid var(--victoria-light-rose);
  outline-offset: -2px;
}

@media (max-height: 720px) {
  .mine-header {
    padding-top: 0.1rem;
  }

  .mine-brand {
    width: 4.16rem;
    height: 4.16rem;
  }

  .mine-brand ::v-deep .victoria-brand,
  .mine-brand ::v-deep .victoria-brand__logo {
    width: 3.92rem;
  }

  .stats-card,
  .menu-list {
    margin-top: 0.35rem;
  }

  .menu-item {
    min-height: 1.36rem;
  }
}

@media (min-width: 600px) {
  .list-wrapper {
    width: 10rem;
    margin: 0 auto;
  }
}
</style>
